import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Input, Label } from "reactstrap";
import * as Icon from "react-feather";
import classNames from "classnames";

import "./VideoFilter.scss";
import CustomInput from "./CustomInput";
import SearchUserInput from "./SearchUserInput";
import { isUUID } from "../../helpers/utils";
import DRP from "../../components/DateRangePicker";

const VideoFilter = ({ onSubmitFilter, loading, onToggleShow, paging, startCreatedDate, endCreatedDate }) => {

  const { beginItem, endItem, totalItems, showDatatable } = paging;

  const VIDEO_TYPES = ['LECTURE', 'VIDEOS', 'SEEDS', 'HOTS'];

  var videoIdInput = useRef(null);
  var keywordInput = useRef(null);

  const [cancelDebounce, setCancelDebounce] = useState(false);
  const [validateErrors, setValidateErrors] = useState({});

  const [filters, setFilters] = useState({
    types: [],
    keywords: '',
    videoId: '',
    videoOwner: '',
    types: VIDEO_TYPES,
    startCreatedDate: startCreatedDate,
    endCreatedDate: endCreatedDate,
    order: 'desc',
    excludeIRLVideo: true,
    includeStorage: true,
    reload: false
  });

  const fetching = false; // useSelector(state => state.bouser?.fetching);

  const handleKeywordChange = (value) => {
    setFilters({ ...filters, keywords: value });
    setCancelDebounce(false);
  }

  const handleKeywordSubmit = (keywords) => {
    setFilters({ ...filters, keywords: keywords, reload: true });
  };

  const handleVideoIdChange = (value) => {
    if (value && !isUUID(value)) {
      setValidateErrors({
        ...validateErrors,
        videoId: 'Video id must be in uuid format.'
      });
    } else {
      let errors = Object.assign({}, validateErrors);
      delete errors.videoId;

      setValidateErrors({
        ...errors
      });
    }
    setCancelDebounce(false);
    setFilters({ ...filters, videoId: value });
  }

  const handleVideoIdSubmit = (videoId) => {
    setCancelDebounce(true);
    setFilters({ ...filters, videoId: videoId, reload: true });
  };

  const handleInputChange = (value, name) => {
    setFilters({ ...filters, [name]: value });
  }

  const handleInputSubmit = (value, name) => {
    setCancelDebounce(true);
    setFilters({ ...filters, [name]: value, reload: true });
  }

  const handleVideoTypeChange = (option) => {
    if (filters.types.includes(option)) {
      setFilters({ ...filters, types: filters.types.filter((item) => item !== option), reload: true });
    } else {
      setFilters({ ...filters, types: [...filters.types, option], reload: true });
    }
  }

  const handleCreatedDateChange = (start, end) => {
    setFilters({ ...filters, startCreatedDate: start, endCreatedDate: end });
  }

  const submitFilter = () => {
    setCancelDebounce(true);
    if (onSubmitFilter) onSubmitFilter(filters);
  };

  useEffect(() => {
    if (filters.reload) {
      submitFilter();
      setFilters({ ...filters, reload: false });
    }
  }, [filters.reload]);



  return (
    <>
      <Row className='video-review-filter'>
        <Col lg="5" md="5" xs="5" className="mt-1 mb-1">
          <div className="d-flex w-100">
            <label htmlFor="" className="mb-0 mr-2 text-right" style={{ width: '120px' }}>Video id</label>
            <div className="w-100">
              <CustomInput
                name="videoId"
                value={filters.videoId}
                className={classNames('w-100', { 'is-invalid': validateErrors.videoId ? true : false })}
                placeholder=""
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleVideoIdChange}
                onSubmit={handleVideoIdSubmit}
                innerRef={videoIdInput}
                maxLength="36"
              />
            </div>
          </div>
        </Col>
        <Col lg="3" md="3" xs="3" className="mt-1 mb-1">
          <div className="d-flex w-100">
            <label htmlFor="" className="mb-0 mr-2 text-right" style={{ width: '120px' }}>Video owner</label>
            <div className="w-100">
              <CustomInput
                name="videoOwner"
                value={filters.videoOwner}
                className="w-100"
                placeholder=""
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleInputChange}
                onSubmit={handleInputSubmit}
              />
            </div>
          </div>
        </Col>
        <Col lg="4" md="4" xs="4" className="mt-1 mb-1">
          <div className="d-flex w-100">
            <label htmlFor="" className="mb-0 mr-2 text-right" style={{ width: '120px' }}>Keywords</label>
            <div className="w-100">
              <CustomInput
                name="keywords"
                value={filters.keywords}
                className="w-100"
                placeholder="Title, subject, topic..."
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleKeywordChange}
                onSubmit={handleKeywordSubmit}
                innerRef={keywordInput}
              />
            </div>
          </div>
        </Col>

      </Row>
      <Row className="mt-2">
        <Col lg="5" md="5" xs="5">
          <div className="d-flex w-100">
            <label htmlFor="" className="mb-0 mr-2 text-right" style={{ width: '120px' }}>Video types</label>
            <div className="pl-1 pt-1 pr-1 w-100" style={{ display: 'flex', alignItems: 'center', border: 'solid 1px rgb(207, 213, 219)' }} >
              {VIDEO_TYPES.map((option, index) => (
                <div key={index} className="w-100">
                  <Input
                    type="checkbox"
                    id={`checkbox-${index}`}
                    checked={filters.types.includes(option)}
                    onChange={() => handleVideoTypeChange(option)}
                    className="ml-0"
                  />
                  <Label for={`checkbox-${index}`} className="ml-4">
                    {option}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        </Col>
        <Col lg="7" md="7" xs="7">
          <div className="d-flex w-100">
            <label htmlFor="" className="mb-0 mr-2 text-right" style={{ width: '120px' }}>Created on</label>
            <div className="w-100 d-flex" >
              <DRP
                showApplyButton={false}
                initStart={filters.startCreatedDate}
                initEnd={filters.endCreatedDate}
                onChange={handleCreatedDateChange}
              />
            </div>
          </div>
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col lg="4" className="mt-1 mb-1 align-self-center">

        </Col>
        <Col lg="4"></Col>
        <Col lg="4" className="mt-1 mb-1 d-flex align-self-center justify-content-end">
          {showDatatable && (
            <div className="font-weight-bold mt-1 mr-2 d-flex"><span className="">{`${beginItem}-${endItem > totalItems ? totalItems : endItem} of ${totalItems} video${totalItems > 1 ? 's' : ''}`}</span></div>
          )}
          <Button
            className="ml-3"
            size=""
            disabled={loading}
            // color="secondary"
            onClick={(e) => { setCancelDebounce(true); submitFilter(e); }}
          >
            <Icon.Search className="" style={{ width: '15px', height: '15px', marginTop: '-2px' }} /> Search
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(VideoFilter);